// extracted by mini-css-extract-plugin
module.exports = {"form":"index2_form__BOkb6","title":"index2_title__19W5W","form-control":"index2_form-control__3awMD","button-lg":"index2_button-lg__2i8jk"};